<template>
  <div class="page-wrap">
    <Header></Header>

    <div class="apply-area flex-r-center">
      <div class="card-width">
        <el-card>
          <div slot="header" class="card-wrap flex-center-center fz24">
            <div
                class="tab-item tab-item-active"
            >
              印章种类选择
            </div>
          </div>

          <div class="flex-center-between mb50">

            <div style="padding: 20px;width: 48%" :class="type == 'physics' ? 'box-change' : 'box-nochange'"
                 @click="changeType('physics')">
              <img src="@/assets/physics-seal.png" style="width: 100%" alt="">
              <div>物理印章申领(目前仅支持朝阳地区使用)</div>
            </div>

            <div style="padding: 20px;width: 48%" :class="type == 'electron' ? 'box-change' : 'box-nochange'"
                 @click="changeType('electron')">
              <img src="@/assets/electron-seal.png" style="width: 100%" alt="">
              <div>电子印章申领</div>
            </div>

          </div>

          <el-button class="next-button" type="primary" @click="toPath()"
          >前往申领
          </el-button>
        </el-card>
      </div>
    </div>

    <Bottom></Bottom>
  </div>
</template>

<script>

import Header from "@/components/Header.vue";
import Bottom from "@/components/Bottom.vue";

export default {
  name: "sealChange",
  components: {Bottom, Header},
  data() {
    return {
      type: "physics",
    }
  },
  methods: {
    changeType(type) {
      this.type = type;
    },
    toPath() {
      let path = '';
      if (this.type == "physics") {
        path = '/register/operatorAuthentication'
      } else if (this.type == "electron") {
        path = '/register/register'
      }
      this.$router.push({
        path: path
      })
    }
  }
}
</script>

<style scoped lang="less">
.box-change {
  border: 1px solid #67c23a;
}

.box-nochange {
  border: 1px solid #FFFFFF;
}
</style>
